import cloneDeep from 'clone-deep'
import { basicElement, systemElement } from '../system/menu/formElements/data/element'
import {
  staticContainer,
  staticSubContainer,
} from '../system/menu/formElements/data/container'

const SKIP_KEYS = new Set([
  'key',
  'name',
  'scope',
  'index',
  'fieldName',
  'label',
  'title',
  'elements',
  'layout',
  'uiType',
  'tagname',
  'type',
  'isShowUi',
  'isShowField',
  'modal',
  'part',
  'subGroup',
  'groupKey',
  'dynamicKey',
  'dynamicName',
  'isInsideDynamic',
  'options',
  'param',
  'valuePattern',
  'favorite',
])

/** ค่า default ที่ตรงกับพฤติกรรมตอน render (สำหรับ element เก่าที่ field ยังเป็น undefined) */
const RENDER_OVERRIDES = {
  button: {
    buttonType: 'fill',
    buttonPosition: 'left',
  },
  buttonDropdown: {
    buttonType: 'fill',
    buttonPosition: 'left',
  },
}

/** ค่าใน properties panel ที่ไม่มีใน template ตอนสร้าง element */
const PROPERTY_EXTRAS = {
  panel: { layoutDesign: 1 },
  panelGroup: { layoutDesign: 1 },
  image: { objectFit: 'contain', shape: 'square' },
  video: { objectFit: 'contain', shape: 'square' },
  dynamic: { panelPattern: 'down', panelLayoutWidth: 'auto' },
  tab: { navLayout: '', isKeepTabRender: true },
  time: { timeFormatType: 'system' },
  date: { formatType: 'system' },
  dateTime: { formatType: 'system', timestamp: false },
  checkbox: { checkboxPosition: 'left', checkboxWidth: '18px' },
  checkboxInput: { checkboxPosition: 'left', checkboxWidth: '18px' },
  checkboxGroup: { valueType: 'default', optionType: 'default' },
  gallery: { galleryType: 'view', viewGalleryType: 'array' },
  textarea: { rows: 3 },
  table: { rowPadding: '16px', rowsPerPage: 10, isPaging: true },
  customTable: { rowPadding: '16px', rowsPerPage: 10, isPaging: true, startRow: 1 },
  inputMask: { maskChar: '_' },
}

const buildTemplateMap = () => {
  const map = {}
  const register = (items = []) => {
    items.forEach((item) => {
      if (item?.id && item?.uischema) {
        map[item.id] = item.uischema
      }
    })
  }
  register(basicElement)
  register(systemElement)
  register(staticContainer)
  register(staticSubContainer)
  return map
}

const UI_TEMPLATE_BY_TAG = buildTemplateMap()

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const resolveDefaultValue = (tagname, key, templateValue) => {
  if (RENDER_OVERRIDES[tagname] && key in RENDER_OVERRIDES[tagname]) {
    return RENDER_OVERRIDES[tagname][key]
  }
  return templateValue
}

const fillUndefinedKeys = (target, source, tagname) => {
  if (!isPlainObject(source)) return false

  let changed = false
  Object.keys(source).forEach((key) => {
    if (SKIP_KEYS.has(key)) return

    const templateValue = source[key]
    const targetValue = target[key]

    if (isPlainObject(templateValue)) {
      if (targetValue === undefined) {
        target[key] = cloneDeep(templateValue)
        changed = true
      } else if (isPlainObject(targetValue)) {
        if (fillUndefinedKeys(targetValue, templateValue, tagname)) {
          changed = true
        }
      }
      return
    }

    if (targetValue === undefined) {
      target[key] = resolveDefaultValue(tagname, key, templateValue)
      changed = true
    }
  })

  return changed
}

/**
 * เติมค่า config ที่ยังไม่ถูกกำหนด (undefined) จาก template / property defaults
 * ให้เมนู Properties ตรงกับ element บน canvas และ persist ลง uischema
 */
export const applyUiDefaults = (ui = {}) => {
  if (!ui?.tagname) return false

  const tagname = ui.tagname
  const template = UI_TEMPLATE_BY_TAG[tagname]
  const extras = PROPERTY_EXTRAS[tagname] || {}

  let changed = false

  if (template) {
    if (fillUndefinedKeys(ui, template, tagname)) {
      changed = true
    }
  }

  if (Object.keys(extras).length > 0) {
    if (fillUndefinedKeys(ui, extras, tagname)) {
      changed = true
    }
  }

  return changed
}

export default applyUiDefaults
